module.exports = __webpack_public_path__ + "static/img/IMG_6353.598f84c.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/items/ajandektargyak/IMG_6353.jpg
// module id = 534
// module chunks = 0